import type { ReactNode } from 'react';

export type DateScopeAvailability = 'ready' | 'invalid';

interface DateScopeGuardProps {
  availability: DateScopeAvailability;
  children: ReactNode;
}

/**
 * The single recovery boundary for content whose queries depend on a date
 * range. Recovery actions remain owned by the shell above this boundary.
 */
export function DateScopeGuard({ availability, children }: DateScopeGuardProps) {
  if (availability === 'invalid') {
    return (
      <p role="status" className="rounded-md border border-degraded-border bg-degraded-surface p-4 text-sm text-degraded-foreground">
        Invalid date range. Use Edit dates or Reset to All above.
      </p>
    );
  }

  return children;
}
